import React from 'react';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useModuleConfig } from '../context/ModuleConfigContext';

interface ContentPageProps {
  contentKey: string;
}

const ContentPage: React.FC<ContentPageProps> = ({ contentKey }) => {
  const { t } = useTranslation();
  const { config } = useModuleConfig();

  // Get the raw HTML content
  const htmlContent = t(contentKey, { defaultValue: '' });

  // Interpolate portal config variables like {{phone}}, {{email}}, {{portalName}}
  const interpolatedContent = htmlContent
    .replace(/\{\{phone\}\}/g, config?.portal?.phone || '038 20 22 835')
    .replace(/\{\{email\}\}/g, config?.portal?.infoMailAddress || 'sales@kovvar.com')
    .replace(/\{\{portalName\}\}/g, config?.portal?.name || 'Kovvar B2B Portal');

  return (
    <Container className="py-4">
      <div
        className="content-page"
        dangerouslySetInnerHTML={{ __html: interpolatedContent }}
      />
    </Container>
  );
};

export default ContentPage;
